export const leavesTooltip = {
    title: 'Order Leaves',
    body: 'refers to the unexecuted portion of your order in shares.',
};

export const percentPredictedRemainingVolTooltip = {
    title: 'Predicted Remaining Volume',
    body: ' is the % that my order leaves account for in the predicted market volume from now.',
};

export const percentCloseTooltip = {
    title: '% Predicted Close Volume',
    body: ' is the % that my order accounts for in the predicted market close auction.',
};

export const histVolTilNowTooltip = {
    title: 'Historical Market Traded Volume until Now',
    body: ' is the historical market traded volume (averaged over the last 20 days) from open until now, expressed in shares. This includes continuous and auction trading.',
};

export const histVolRodTooltip = {
    title: 'Historical Market Traded Volume Rest of Day',
    body: ' is the historical market traded volume (averaged over the last 20 days) from now until close, expressed in shares. This includes continuous and auction trading.',
};

export const todaysVolTilNowTooltip = {
    title: "Today's Market Traded Volume until Now",
    body: " is today's market volume from open until now expressed in shares.",
};

export const todaysVolRODTooltip = {
    title: "Today's Market Volume Rest of Day",
    body: " is the rest of day's predicted volume. This is the historical volume (averaged over the last 20 days) with today's adjustment.",
};

export const auctionOpenTooltip = {
    title: 'Historical Open Auction',
    body: ' is the market historical traded volume in the open auction (averaged over the last 20 days).',
};

export const auctionCloseTooltip = {
    title: 'Historical Closing Auction',
    body: ' is the market historical traded volume in the close auction (averaged over the last 20 days).',
};

export const todaysAdjTooltip = {
    title: "Today's Adjustment until Now",
    body: " is the % change in market volume today versus historical volume. It indicates if today's market volume is higher, lower or the same as the historical average. This value is used to predict the rest of day volume.",
};

export const todaysPredictedAdjTooltip = {
    title: "Today's Adjustment Rest of Day",
    body: ' is the forecasted % change in predicted market volume versus historical volume from now until close.',
};

export const auctionPredTooltip = {
    title: "Today's Predicted Closing Auction",
    body: ' is the forecasted traded volume in the close auction.',
};
